import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '~/hooks/useHttpClient';
import { sanitizeTagValue } from '~/utils/instrumentation';
import { createLogger } from '~/utils/logging';
import { ClientError } from '~/errors';

const log = createLogger('useResendVerificationEmailMutation');

export type ResendVerificationEmailRequest = {
  email: string;
};

export function useResendVerificationEmailMutation() {
  const httpClient = useHttpClient();

  const { mutate, status } = useMutation({
    mutationFn: async (request: ResendVerificationEmailRequest) => {
      log.debug('Resending verification email');
      await httpClient.post('/auth/resendVerification', request);
      log.info('Verification email resent successfully');
    },
    onError: (err: Error) => {
      if (err instanceof ClientError) {
        // Ignore client errors.
      } else {
        log.error('Failed to resend verification email', {
          errorMessage: sanitizeTagValue(err.message),
        });
      }
    },
  });

  return { mutate, status };
}
